import ListFilterType from 'www/modules/Filters/ListFilterType'

export default class FilterTypeService extends ListFilterType {
  constructor(list) {
    super()
    this.list = FilterTypeService.formatList(list)
  }

  static formatList(list) {
    return list.map(service => ({
      value: service.translit,
      name: service.name,
    }))
  }
}
